<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="card">
                    <div class="grid">
                        <div class="col-12 md:col-4 md:col-offset-3">
                            <h5>Покупатель</h5>
                            <div class="col-12">
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon">
                                        <i class="pi pi-user"></i>
                                    </span>
                                    <InputText
                                        v-model="buyer"
                                        :readonly="buyerReadonly"
                                        @blur="onBuyerBlur"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-2">
                            <h5>Скидка</h5>
                            <div class="col-12">
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon">
                                        <i class="pi pi-percentage"></i>
                                    </span>
                                    <InputNumber :use-grouping="false" :max="99" :min="0" v-model="defaultPercent" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-col-12">
                <div class="card">
                    <DataTable
                        ref="dt"
                        :value="datatable.data"
                        :loading="datatable.loading"
                        rowGroupMode="rowspan"
                        :groupRowsBy="['competitor_article_name','competitor_article_id']"
                        @rowReorder="onRowReorder"
                        style="font-size: 12px; overflow-x: auto"
                    >
                        <template #header>
                            <div style="text-align: left">
                                <Button icon="pi pi-external-link" label="Скачать" @click="downloadKP" :disabled="competitorIds.length < 1" />
                            </div>
                        </template>
                        <template #groupheader="slotProps">
                            <img src="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png" width="32" style="vertical-align: middle" />
                            <span class="image-text">test</span>
                        </template>
                        <Column field="competitor_article_id" :rowReorder="true" :reorderableColumn="false" header="">
                            <template #body="slotProps">
                                <div class="table-actions">
                                    <i :class="['p-datatable-reorderablerow-handle', 'pi pi-bars']" v-if="!slotProps.data.virtual"></i>
                                    <Button
                                        icon="pi pi-times"
                                        class="p-button-rounded p-button-danger p-button-text"
                                        @click="deleteItem(slotProps)"
                                        v-if="!isLastVirtualTableRow(slotProps.index)"
                                    />
                                </div>
                            </template>
                        </Column>
                        <Column field="competitor_article_name" :header="isClientRole() ? 'Введите Артикул/наименование' : 'Введите Артикул Конкурента'">
                            <template #body="slotProps">
                                <AutoComplete
                                    @paste="onPaste($event, slotProps)"
                                    v-model="slotProps.data.competitor_article_name"
                                    @update:modelValue="addSelectedCompetitorArticle($event, slotProps)"
                                    :suggestions="filteredCompetitorArticles"
                                    @complete="searchCompetitorArticle($event)"
                                    field="name"
                                    v-if="slotProps.data.virtual"
                                />

                                <AutoComplete
                                    @paste="onPaste($event, slotProps)"
                                    v-model="this.competitorArticleNameEdit[slotProps.data.competitor_article_id]['data']"
                                    @update:modelValue="updateSelectedCompetitorArticle($event, slotProps)"
                                    :suggestions="filteredCompetitorArticles"
                                    @complete="searchCompetitorArticle($event, slotProps.index)"
                                    field="name"
                                    @blur="hideCompetitorArticleNameEdit(slotProps.data.competitor_article_id)"
                                    :ref="'autocomplete_article_' + slotProps.data.competitor_article_id"
                                    v-else-if="this.competitorArticleNameEdit[slotProps.data.competitor_article_id] && this.competitorArticleNameEdit[slotProps.data.competitor_article_id]['show']"
                                />
                                <span
                                    :class="{'bold': slotProps.data.should_sum}"
                                    @click="showCompetitorArticleNameEdit(slotProps.data.competitor_article_id, slotProps.data.competitor_article_name)"
                                    v-else
                                >
                                    {{slotProps.data.competitor_article_name}}
                                </span>
                            </template>
                        </Column>
                        <Column field="vector_article_name" header="Наименование товара Вектор-ВС">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual">-</span>
                                <span :class="{'bold': slotProps.data.should_sum}" v-else>{{ slotProps.data.vector_article_name }}</span>
                            </template>
                        </Column>
                        <Column field="competitor_name" header="Название конкурента" v-if="canShow('competitor_name')">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual">-</span>
                                <span :class="{'bold': slotProps.data.should_sum}" v-else>{{ slotProps.data.competitor_name }}</span>
                            </template>
                        </Column>
                        <Column field="competitor_price" header="Цена конкурента" v-if="canShow('competitor_price')">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual || !slotProps.data.should_sum">-</span>
                                <span v-else>{{ slotProps.data.competitor_price }}</span>
                            </template>
                        </Column>
                        <Column field="discount" header="Скидка" class="table-input-small">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual">-</span>
                                <span class="p-input-icon-right" v-else-if="slotProps.data.should_sum">
                                    <i class="pi pi-percentage" />
                                    <InputNumber :use-grouping="false" :max="99" :min="0" v-model="tableDiscount[slotProps.data.competitor_article_id]" />
                                </span>
                                <span v-else>{{ tableDiscount[slotProps.data.competitor_article_id] }}%</span>
                            </template>
                        </Column>
                        <Column field="our_price" :header="isClientRole() ? 'Ваша цена' : 'Наша цена'">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual">-</span>
                                <span :class="{'bold': slotProps.data.should_sum}" v-else>
                                   {{ slotProps.data.our_price ? calculateOurPrice(slotProps.index, slotProps.data.competitor_article_id).toFixed(2) : '0' }}
                                </span>
                            </template>
                        </Column>
                        <Column field="parity_discount" header="Необходимая до паритета скидка" v-if="canShow('parity_discount')">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual || !slotProps.data.should_sum">-</span>
                                <span v-else>
                                    {{ slotProps.data.parity_discount ? (slotProps.data.parity_discount*100).toFixed(0) : '0' }}%
                                </span>
                            </template>
                        </Column>
                        <Column field="quantity" header="Количество" class="table-input-small">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual">-</span>
                                <span :class="{'bold': slotProps.data.should_sum}" class="p-input-icon-right" v-else-if="slotProps.data.should_sum">
                                    <InputNumber :use-grouping="false" :min="0" type="text" v-model="tableCount[slotProps.data.competitor_article_id]" />
                                </span>
                                <span v-else>{{ tableCount[slotProps.data.competitor_article_id]*slotProps.data.required_count }}</span>
                            </template>
                        </Column>
                        <Column field="competitor_full_price" header="Сумма конкурента" v-if="canShow('competitor_full_price')">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual || !slotProps.data.should_sum">-</span>
                                <span v-else>
                                    {{ slotProps.data.competitor_price ? calculateCompetitorFullPrice(slotProps.index, slotProps.data.competitor_article_id).toFixed(2) : '0' }}
                                </span>
                            </template>
                        </Column>
                        <Column field="our_full_price" :header="isClientRole() ? 'Сумма' : 'Сумма вектор'">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual">-</span>
                                <span :class="{'bold': slotProps.data.should_sum}" v-else>
                                    {{
                                        slotProps.data.our_price ? calculateOurFullPrice(slotProps.index, slotProps.data.competitor_article_id, slotProps.data.required_count).toFixed(2) : '0'
                                    }}
                                </span>
                            </template>
                        </Column>
                        <Column field="we_cheaper" header="Мы дешевле" v-if="canShow('we_cheaper')">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual || !slotProps.data.should_sum">-</span>
                                <span :class="slotProps.data.our_price ? getColorClass(calculateCheaper(slotProps.index, slotProps.data.competitor_article_id)) : ''" v-else>
                                    {{
                                        slotProps.data.our_price ? calculateCheaper(slotProps.index, slotProps.data.competitor_article_id).toFixed(2) : '0'
                                    }}
                                </span>
                            </template>
                        </Column>
                        <Column field="profit" header="Прибыль" v-if="canShow('profit')">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual || !slotProps.data.should_sum">-</span>
                                <span v-else>
                                    {{
                                        slotProps.data.our_price ? calculateProfit(slotProps.index, slotProps.data.competitor_article_id).toFixed(2) : '0'
                                    }}
                                </span>

                            </template>
                        </Column>
                        <Column field="margin" header="Маржа" v-if="canShow('margin')">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.virtual || !slotProps.data.should_sum">-</span>
                                <span v-else>
                                    {{
                                        slotProps.data.our_price ? calculateMargin(slotProps.index, slotProps.data.competitor_article_id).toFixed(0) : '0'
                                    }}%
                                </span>
                            </template>
                        </Column>
                        <Column field="comment" header="Комментарий">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.comment ? slotProps.data.comment : '-'
                                }}
                            </template>
                        </Column>
                        <Column field="url" header="">
                            <template #body="slotProps">
                                <a target="_blank" :href="slotProps.data.url" v-if="slotProps.data.url">Подробнее</a>
                            </template>
                        </Column>
                        <ColumnGroup type="footer">
                            <Row>
                                <Column :colspan="5 + canShow('competitor_price') + canShow('parity_discount') + canShow('competitor_name')"  field="we_cheaper" />
                                <Column footer="Итого:" />
                                <Column :footer="totalCompetitorFullPrice().toFixed(2)" :hidden="!canShow('competitor_full_price')" />
                                <Column :footer="totalOurFullPrice().toFixed(2)" />
                                <Column :footer="totalCheaper().toFixed(2)" :hidden="!canShow('we_cheaper')" />
                                <Column :footer="totalProfit().toFixed(2)" :hidden="!canShow('profit')" />
                                <Column :footer="canShow('margin') ? totalMargin().toFixed(0) + '%' : ''" :colspan="3" />
                            </Row>
                        </ColumnGroup>
                        <template #empty>
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import CalculatorService from "../Services/CalculatorService";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
    },
    data() {
        return {
            filteredCompetitorArticles: null,
            selectedCompetitorArticle: [],
            tableDiscount: {},
            tableCount: {},
            defaultPercent: 0,
            defaultCount: 1,
            buyer: null,
            datatable: {
                loading: false,
                data: [],
                lazyParams: {}
            },
            virtualTableData: [],
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
            selectedTableRow: null,
            emptyRowIndex: 0,
            focused: {},
            buyerReadonly: false,
            competitorIds: [],
            competitorArticleNameEdit: {}
        }
    },
    calculatorService: null,
    created() {
        this.calculatorService = new CalculatorService();
    },
    mounted() {
        this.loadLazyData();

        this.initBuyer();
    },
    methods: {
        onBuyerBlur() {
            if (this.datatable.lazyParams['buyer'] === this.buyer) {
                return;
            }

            this.loadLazyData();
        },
        canShow(cellName) {
            switch (this.$page.props.user.role) {
                case 'sale':
                    if ([
                        'margin',
                        'profit'
                    ].indexOf(cellName) !== -1) {
                        return false;
                    }
                    break;
                case 'osp':
                    if ([
                        'margin',
                        'profit',
                        'we_cheaper',
                        'competitor_full_price',
                        'parity_discount',
                        'competitor_price'
                    ].indexOf(cellName) !== -1) {
                        return false;
                    }

                    break;
                case 'client':
                    if ([
                        'margin',
                        'profit',
                        'we_cheaper',
                        'competitor_full_price',
                        'parity_discount',
                        'competitor_price',
                        'competitor_name'
                    ].indexOf(cellName) !== -1) {
                        return false;
                    }

                    break;
            }

            return true;
        },
        isRole(name) {
            return this.$page.props.user.role === name;
        },
        isClientRole() {
            return this.$page.props.user.role === 'client'
        },
        initBuyer() {
            let user = this.$page.props.user;
            if (user.role === 'client') {
                this.buyer = user.name;
                this.buyerReadonly = true;
            } else {
                this.buyer = null;
                this.buyerReadonly = false;
            }
        },
        selectNext(index) {
            setTimeout(() => {
                this.$refs['autocomplete_article_'+index].focus();
            }, 1)
        },
        totalMargin() {
            let totalCalculateOurFullPrice = this.totalCalculateOurFullPrice();
            if (totalCalculateOurFullPrice === 0) {
                return 0;
            }

            return (totalCalculateOurFullPrice - this.totalOurFullSbsPrice()) / totalCalculateOurFullPrice * 100;
        },
        totalProfit() {
            let totalSum = 0;
            this.datatable.data.forEach(function (value, index) {
                if (!value.virtual && value.should_sum) {
                    totalSum += this.calculateProfit(index, value.competitor_article_id);
                }
            }, this);

            return totalSum;
        },
        totalCheaper() {
            let totalSum = 0;
            this.datatable.data.forEach(function (value, index) {
                if (!value.virtual && value.should_sum) {
                    totalSum += this.calculateCheaper(index, value.competitor_article_id);
                }
            }, this);

            return totalSum;
        },
        totalCompetitorFullPrice() {
            let totalSum = 0;
            this.datatable.data.forEach(function (value, index) {
                if (!value.virtual && value.should_sum) {
                    totalSum += this.calculateCompetitorFullPrice(index, value.competitor_article_id);
                }
            }, this);

            return totalSum;
        },
        totalOurFullPrice() {
            let totalSum = 0;
            this.datatable.data.forEach(function (value, index) {
                if (!value.virtual && value.should_sum) {
                    totalSum += this.calculateOurFullPrice(index, value.competitor_article_id, value.required_count);
                }
            }, this);

            return totalSum;
        },
        totalOurFullSbsPrice() {
            let totalSum = 0;
            this.datatable.data.forEach(function (value, index) {
                if (!value.virtual && value.should_sum) {
                    totalSum += parseInt(value.prime_price) * this.tableCount[value.competitor_article_id];
                }
            }, this);

            return totalSum;
        },
        calculateProfit(index, competitorArticleId) {
            let primePrice = 0;
            if (this.datatable.data[index]['prime_price']) {
                primePrice = this.datatable.data[index]['prime_price'];
            }

            return ((this.calculateOurPrice(index, competitorArticleId) - primePrice)*this.tableCount[competitorArticleId]);
        },
        calculateCheaper(index, competitorArticleId) {
            if (!this.calculateOurFullPrice(index, competitorArticleId)) {
                return 0;
            }

            return this.calculateCompetitorFullPrice(index, competitorArticleId) - this.calculateOurFullPrice(index, competitorArticleId);
        },
        calculateMargin(index, competitorArticleId) {
            if (!this.calculateOurFullPrice(index, competitorArticleId)) {
                return 0;
            }

            return this.calculateProfit(index, competitorArticleId) / this.calculateOurFullPrice(index, competitorArticleId) * 100
        },
        totalCalculateOurFullPrice() {
            let totalSum = 0;
            this.datatable.data.forEach(function (value, index) {
                if (!value.virtual && value.should_sum) {
                    totalSum += this.calculateOurFullPrice(index, value.competitor_article_id);
                }
            }, this);

            return totalSum;
        },
        calculateOurPrice(index, competitorArticleId) {
            if (!this.datatable.data[index]['our_price']) {
                return 0;
            }

            return this.datatable.data[index]['our_price'] * (1 - this.tableDiscount[competitorArticleId] / 100);
        },
        calculateOurFullPrice(index, competitorArticleId, requiredCount = 1) {
            return this.calculateOurPrice(index, competitorArticleId) * this.tableCount[competitorArticleId] * requiredCount;
        },
        calculateCompetitorFullPrice(index, competitorArticleId) {
            if (!this.datatable.data[index]['competitor_price']) {
                return 0;
            }

            return this.datatable.data[index]['competitor_price'] * this.tableCount[competitorArticleId];
        },
        onPaste(event, slotProps) {
            if (typeof slotProps.data.virtual === "undefined") {
                return;
            }

            let virtualCompetitorArticleId = slotProps.data.competitor_article_id;
            this.deleteVirtualTableDataRow(virtualCompetitorArticleId);

            let separatedData = event.clipboardData.getData('text').toLowerCase().split(/\r?\n/);
            this.calculatorService.getData(this.route('api.vector.batch_article_competitor'), {
                search: separatedData,
            }).then(data => {
                Object.keys(data.data).forEach(function (value) {
                    if (null === data.data[value]) {
                        this.addVirtualTableDataRow(value);
                        return;
                    }
                    this.addCompetitorId(data.data[value].id);
                }, this)

                this.loadLazyData();
            });

            // let separatedData = event.clipboardData.getData('text').split(/\r?\n/);
            // setTimeout(() => {
            //     separatedData.forEach(function (value, indexData) {
            //         if (indexData > 0) {
            //         }
            //         this.selectedCompetitorArticle[index + indexData] = separatedData[indexData];
            //         this.datatable.data[index + indexData]['competitor_article_name'] = separatedData[indexData];
            //     }, this);
            //     this.loadLazyData();
            // }, 0);
        },
        getColorClass(value) {
            if (value === 0) {
                return '';
            }

            if (value > 0) {
                return 'text-green-700';
            }

            return 'p-error';
        },
        updateSelectedCompetitorArticle(value, slotProps) {
            if (typeof value !== 'object') {
                return;
            }

            this.replaceCompetitorId(slotProps.data.competitor_article_id, value.id);

            this.loadLazyData();
        },
        addCompetitorId(id) {
            if (this.competitorIds.indexOf(id) === -1) {
                this.competitorIds.push(id);
            } else {
                if (typeof this.tableCount[id] === 'undefined') {
                    this.tableCount[id] = this.defaultCount;
                } else {
                    this.tableCount[id]++;
                }
            }
        },
        replaceCompetitorId(id, replaceById) {
            let idIndex = this.competitorIds.indexOf(id);
            if (idIndex === -1) {
                return;
            }

            if (this.competitorIds.indexOf(replaceById) === -1) {
                this.competitorIds[idIndex] = replaceById;
            } else {
                this.tableCount[replaceById]++;
                this.competitorIds.splice(idIndex, 1);
            }
        },
        addSelectedCompetitorArticle(value, slotProps) {
            if (typeof value !== 'object') {
                return;
            }

            this.addCompetitorId(value.id);
            if (slotProps.data.virtual) {
                this.deleteVirtualTableDataRow(slotProps.data.competitor_article_id);
            }
            this.loadLazyData();
        },
        deleteItem(slotProps) {
            if (slotProps.data.virtual) {
                this.deleteVirtualTableDataRow(slotProps.data.competitor_article_name);
            } else if (slotProps.data.competitor_article_id) {
                let index = this.competitorIds.indexOf(slotProps.data.competitor_article_id);
                this.competitorIds.splice(index, 1);
            }

            this.loadLazyData();

            //
            // let articleCompetitorName = this.datatable.data[itemIndex]['competitor_article_name'];
            // let deleteRows = [];
            // this.datatable.data.forEach(function (value, index) {
            //     if (value['competitor_article_name'] === articleCompetitorName) {
            //         deleteRows.push(index);
            //     }
            // }, this);
            //
            // deleteRows.reverse().forEach(function (value, index) {
            //     this.deleteCurrentRow(value);
            // }, this);
        },

        searchCompetitorArticle(event) {
            this.calculatorService.getData(this.route('api.vector.article_competitor'), {
                search: event.query.toLowerCase(),
            }).then(data => {
                this.filteredCompetitorArticles = data.data;
            });
        },

        getLastVirtualRowIndex(dataTableIndex) {
            let virtualTableIndex = dataTableIndex - (this.datatable.data.length - 1);
            if (virtualTableIndex < 0) {
                throw 'it is not virtual row';
            }

            return virtualTableIndex;
        },
        isLastVirtualTableRow(dataTableIndex) {
            if (dataTableIndex === (this.datatable.data.length - 1)) {
                return true;
            }

            return false;
        },
        addVirtualTableDataRow(competitorArticleName) {
            if (this.findVirtualTableRowIndex(competitorArticleName) !== -1) {
                return;
            }

            this.virtualTableData.push({
                virtual: {},
                competitor_article_id: competitorArticleName,
                competitor_article_name: competitorArticleName,
            });
        },
        findVirtualTableRowIndex(competitorArticleName) {
            let virtualTableRowIndex = -1;
            this.virtualTableData.forEach(function (value, index) {
                if (value.competitor_article_id === competitorArticleName) {
                    virtualTableRowIndex = index;
                    return;
                }
            })

            return virtualTableRowIndex;
        },
        deleteVirtualTableDataRow(competitorArticleName) {
            let virtualTableIndex = this.findVirtualTableRowIndex(competitorArticleName);

            this.virtualTableData.splice(virtualTableIndex, 1);
        },
        loadLazyData() {
            this.datatable.lazyParams = {
                search: this.competitorIds,
            };
            this.datatable.loading = true;
            this.datatable.lazyParams['buyer'] = this.buyer;
            this.calculatorService.getData(this.route('api.vector.list'), this.datatable.lazyParams).then(data => {
                if (this.virtualTableData.length < 1) {
                    this.addVirtualTableDataRow();
                }
                this.datatable.data = data.data.concat(this.virtualTableData);

                this.defineDefaultData();

                this.datatable.loading = false;
            });
        },
        defineDefaultData() {
            this.datatable.data.forEach(function (data, index) {
                if (!data.competitor_article_id) {
                    return;
                }
                if (typeof this.tableDiscount[data.competitor_article_id] === "undefined") {
                    this.tableDiscount[data.competitor_article_id] = this.defaultPercent;
                }
                if (typeof this.tableCount[data.competitor_article_id] === "undefined") {
                    this.tableCount[data.competitor_article_id] = this.defaultCount;
                }
            }, this);
        },
        onRowReorder(event) {
            if (event.dragIndex === event.dropIndex) {
                return;
            }

            let moveId = this.datatable.data[event.dragIndex]['competitor_article_id'];
            let beforeId = this.datatable.data[event.dropIndex]['competitor_article_id'];

            let indexId = this.competitorIds.indexOf(moveId);
            let indexBeforeId = this.competitorIds.indexOf(beforeId);
            this.moveArrayItem(this.competitorIds, indexId, indexBeforeId);
            this.loadLazyData();
        },
        moveArrayItem(arr, fromIndex, toIndex) {
            let element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            arr.splice(toIndex, 0, element);
        },
        showCompetitorArticleNameEdit(competitorArticleId, competitorArticleName) {
            this.competitorArticleNameEdit[competitorArticleId] = {
                'show': true,
                'data': competitorArticleName,
            };
            setTimeout(() => {
                this.$refs['autocomplete_article_'+competitorArticleId].focus();
            }, 1)
        },
        hideCompetitorArticleNameEdit(competitorArticleId) {
            setTimeout(() => {
                this.competitorArticleNameEdit[competitorArticleId]['show'] = false;
            }, 300)
        },
        downloadKP() {

            axios.post(this.route('api.vector.download-kp'), {
                ids: this.competitorIds,
                discounts: this.tableDiscount,
                counts: this.tableCount,
                buyer: this.buyer
            },
                {
                    responseType: 'blob'
                }
            )
            .then(function (result) {
                let blob = new Blob([result.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'kp-'+Date.now()+'.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        }
    },
    watch: {
        defaultPercent(newValue) {
            this.competitorIds.forEach(function (value) {
                this.tableDiscount[value] = newValue;
            }, this);
        }
    }
}
</script>

<style scoped>

</style>
